import { ChameleonRequest } from "@repo/chameleon-request";
import { getApiUrl } from "@repo/utils/get-api-url";
import { BagResponseV4 } from "./bag.type";
import { buildExpandQueryValue, ExpandOptions } from "./utils/expand";

export type GetBagByIdOptions = {
  chameleonRequestInstance: ChameleonRequest;
  store: string;
  bagId: string;
  lang: string;
  authHeader: string;
  expand?: ExpandOptions;
};

export async function getBagById({
  chameleonRequestInstance,
  store,
  bagId,
  lang,
  expand,
  authHeader,
}: GetBagByIdOptions) {
  const query = new URLSearchParams({
    lang,
  });

  const expandQueryValue = buildExpandQueryValue(expand);

  if (expandQueryValue) {
    query.append("expand", expandQueryValue);
  }

  const url = getApiUrl({
    path: `/commerce/bag/v4/bags/${bagId}`,
    searchParams: {
      lang,
      ...(expandQueryValue ? { expand: expandQueryValue } : {}),
    },
  });

  const { data, responseHeaders } =
    await chameleonRequestInstance.get<BagResponseV4>(
      url,
      {
        headers: {
          "asos-c-store": store,
          Authorization: authHeader,
        },
      },
      {
        requestType: "GET_BAG_BY_ID_API",
      },
    );

  return {
    data,
    bagSessionToken: responseHeaders["asos-bag-session-token"] as string,
  };
}
